// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardBody,
//   Col,
//   Container,
//   Input,
//   Label,
//   Row,
//   Button,
//   Form,
//   FormFeedback,
//   Alert,
//   Spinner,
// } from "reactstrap";
// import { useSelector, useDispatch } from "react-redux";
// import { Link } from "react-router-dom";
// import withRouter from "../../Components/Common/withRouter";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import { loginUser, resetLoginFlag } from "../../slices/thunks";

// import { createSelector } from "reselect";

// const Login = (props) => {
//   const dispatch = useDispatch();

//   const selectLayoutState = (state) => state;
//   const loginpageData = createSelector(selectLayoutState, (state) => ({
//     user: state.Account.user,
//     error: state.Login.error,
//     loading: state.Login.loading,
//     errorMsg: state.Login.errorMsg,
//   }));

//   const { user, error, loading, errorMsg } = useSelector(loginpageData);
//   const [userLogin, setUserLogin] = useState([]);
//   const [passwordShow, setPasswordShow] = useState(false);
//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       username: userLogin.email,
//       password: userLogin.password,
//     },
//     validationSchema: Yup.object({
//       // username: Yup.string().required("Please Enter Your Email"),
//       username: Yup.string()
//         .test(
//           "email-or-phone",
//           "Must be a valid email or mobile number",
//           (value) => {
//             if (!value) return false;
//             const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//             const phoneRegex = /^[0-9]{10,15}$/;
//             return emailRegex.test(value) || phoneRegex.test(value);
//           }
//         )
//         .required("Please Enter Your Username"),
//       password: Yup.string().required("Please Enter Your Password"),
//     }),

//     onSubmit: (values) => {
//       console.log("login user", values);
//       dispatch(loginUser(values, props.router.navigate));
//     },
//   });

//   useEffect(() => {
//     if (errorMsg) {
//       setTimeout(() => {
//         dispatch(resetLoginFlag());
//       }, 3000);
//     }
//   }, [dispatch, errorMsg]);
//   document.title = "SM Transport";
//   return (
//     <React.Fragment>
//       {/* <ParticlesAuth> */}
//       <div className="auth-page-content mt-lg-5">
//         <Container>
//           {/* <Row>
//                             <Col lg={12}> */}
//           {/* <div className="text-center mt-sm-5 mb-4 text-white-50">
//                                     <div>
//                                         <Link to="/" className="d-inline-block auth-logo">
//                                             <img src={logoLight} alt="" height="20" />
//                                         </Link>
//                                     </div>
//                                     <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p>
//                                 </div> */}
//           {/* </Col>
//                         </Row> */}

//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="mt-4">
//                 <CardBody className="p-4">
//                   <div className="text-center mt-2">
//                     <h5 className="text-success">Welcome </h5>
//                   </div>
//                   {error && error ? (
//                     <Alert color="danger"> {error} </Alert>
//                   ) : null}
//                   <div className="p-2 mt-4">
//                     <Form
//                       onSubmit={(e) => {
//                         e.preventDefault();
//                         validation.handleSubmit();
//                         return false;
//                       }}
//                       action="#"
//                     >
//                       <div className="mb-3">
//                         <Label htmlFor="email" className="form-label">
//                           Username
//                         </Label>
//                         <Input
//                           name="username"
//                           className="form-control"
//                           placeholder="Enter email"
//                           type="text"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.username || ""}
//                           invalid={
//                             validation.touched.username &&
//                             validation.errors.username
//                               ? true
//                               : false
//                           }
//                         />
//                         {validation.touched.username &&
//                         validation.errors.username ? (
//                           <FormFeedback type="invalid">
//                             {validation.errors.username}
//                           </FormFeedback>
//                         ) : null}
//                       </div>

//                       <div className="mb-3">
//                         <div className="float-end">
//                           <Link to="/forgot-password" className="text-muted">
//                             Forgot password?
//                           </Link>
//                         </div>
//                         <Label className="form-label" htmlFor="password-input">
//                           Password
//                         </Label>
//                         <div className="position-relative auth-pass-inputgroup mb-3">
//                           <Input
//                             name="password"
//                             value={validation.values.password || ""}
//                             type={passwordShow ? "text" : "password"}
//                             className="form-control pe-5"
//                             placeholder="Enter Password"
//                             onChange={validation.handleChange}
//                             onBlur={validation.handleBlur}
//                             invalid={
//                               validation.touched.password &&
//                               validation.errors.password
//                                 ? true
//                                 : false
//                             }
//                           />
//                           {validation.touched.password &&
//                           validation.errors.password ? (
//                             <FormFeedback type="invalid">
//                               {validation.errors.password}
//                             </FormFeedback>
//                           ) : null}
//                           <button
//                             className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
//                             type="button"
//                             id="password-addon"
//                             onClick={() => setPasswordShow(!passwordShow)}
//                           >
//                             <i className="ri-eye-fill align-middle"></i>
//                           </button>
//                         </div>
//                       </div>

//                       {/* <div className="form-check">
//                         <Input
//                           className="form-check-input"
//                           type="checkbox"
//                           value=""
//                           id="auth-remember-check"
//                         />
//                         <Label
//                           className="form-check-label"
//                           htmlFor="auth-remember-check"
//                         >
//                           Remember me
//                         </Label>
//                       </div> */}

//                       <div className="mt-4">
//                         <Button
//                           color="success"
//                           disabled={error ? null : loading ? true : false}
//                           className="btn btn-success w-100"
//                           type="submit"
//                         >
//                           {loading ? (
//                             <Spinner size="sm" className="me-2">
//                               {" "}
//                               Loading...{" "}
//                             </Spinner>
//                           ) : null}
//                           Sign In
//                         </Button>
//                       </div>

//                       {/* <div className="mt-4 text-center">
//                                                     <div className="signin-other-title">
//                                                         <h5 className="fs-13 mb-4 title">Sign In with</h5>
//                                                     </div> */}
//                       {/* <div>
//                                                         <Link
//                                                             to="#"
//                                                             className="btn btn-primary btn-icon me-1"
//                                                             onClick={e => {
//                                                                 e.preventDefault();
//                                                                 socialResponse("facebook");
//                                                             }}
//                                                         >
//                                                             <i className="ri-facebook-fill fs-16" />
//                                                         </Link>
//                                                         <Link
//                                                             to="#"
//                                                             className="btn btn-danger btn-icon me-1"
//                                                             onClick={e => {
//                                                                 e.preventDefault();
//                                                                 socialResponse("google");
//                                                             }}
//                                                         >
//                                                             <i className="ri-google-fill fs-16" />
//                                                         </Link>
//                                                         <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
//                                                         <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
//                                                     </div> */}
//                       {/* </div> */}
//                     </Form>
//                   </div>
//                 </CardBody>
//               </Card>

//               {/* <div className="mt-4 text-center">
//                                     <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
//                                 </div> */}
//             </Col>
//           </Row>
//         </Container>
//       </div>
//       {/* </ParticlesAuth> */}
//     </React.Fragment>
//   );
// };

// export default withRouter(Login);

import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, resetLoginFlag } from "../../slices/thunks";
import { createSelector } from "reselect";
import log from "../../assets/images/sl.png";

const Login = (props) => {
  const dispatch = useDispatch();

  const loginSelector = createSelector(
    (state) => state,
    (state) => ({
      user: state.Account.user,
      error: state.Login.error,
      loading: state.Login.loading,
      errorMsg: state.Login.errorMsg,
    })
  );

  const { error, loading, errorMsg } = useSelector(loginSelector);

  const [passwordShow, setPasswordShow] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .test(
          "email-or-phone",
          "Enter valid email or mobile number",
          (value) => {
            if (!value) return false;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const phoneRegex = /^[0-9]{10,15}$/;
            return emailRegex.test(value) || phoneRegex.test(value);
          }
        )
        .required("Username is required"),

      password: Yup.string().required("Password is required"),
    }),

    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    },
  });

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  document.title = "Transport Billing Login";

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #E3F0FF 0%, #D4E4FF 40%, #C3D3FF 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "40px",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card
              className="mt-4"
              style={{
                borderRadius: "18px",
                boxShadow: "0px 6px 22px rgba(0,0,0,0.15)",
                background: "#ffffff",
                padding: "0",
              }}
            >
              <CardBody className="p-4">
                {/* === LOGO === */}
                <div className="text-center mb-3">
                  <img
                    src={log}
                    alt="Logo"
                    style={{
                      width: "90px",
                      height: "90px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      boxShadow: "0 0 5px rgba(0,0,0,0.15)",
                      marginBottom: "10px",
                    }}
                  />
                  <h4 style={{ color: "#405189", fontWeight: "600" }}>
                    Welcome
                  </h4>
                  <p style={{ color: "#6c757d", marginTop: "5px" }}>
                    Login to continue
                  </p>
                </div>

                {error ? <Alert color="danger">{error}</Alert> : null}

                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  {/* USERNAME */}
                  <div className="mb-3">
                    <Label className="form-label">Username</Label>
                    <Input
                      name="username"
                      placeholder="Enter email or mobile"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.username}
                      invalid={
                        validation.touched.username &&
                        validation.errors.username
                      }
                    />
                    {validation.touched.username &&
                    validation.errors.username ? (
                      <FormFeedback>{validation.errors.username}</FormFeedback>
                    ) : null}
                  </div>

                  {/* PASSWORD */}
                  <div className="mb-3">
                    <div className="float-end">
                      <Link to="/forgot-password" className="text-muted">
                        Forgot password?
                      </Link>
                    </div>
                    <Label className="form-label">Password</Label>

                    <div className="position-relative">
                      <Input
                        name="password"
                        type={passwordShow ? "text" : "password"}
                        placeholder="Enter password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                        }
                        style={{ paddingRight: "45px" }}
                      />

                      <button
                        type="button"
                        onClick={() => setPasswordShow(!passwordShow)}
                        style={{
                          border: "none",
                          background: "none",
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#6c757d",
                          fontSize: "18px",
                        }}
                      >
                        <i className="ri-eye-fill"></i>
                      </button>

                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback>
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </div>

                  {/* BUTTON */}
                  <div className="mt-4">
                    <Button
                      color="success"
                      className="w-100"
                      type="submit"
                      disabled={loading}
                      style={{
                        height: "45px",
                        borderRadius: "8px",
                        fontSize: "16px",
                      }}
                    >
                      {loading && (
                        <Spinner size="sm" className="me-2">
                          Loading...
                        </Spinner>
                      )}
                      Sign In
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(Login);
